import React, {PureComponent} from 'react';
import { connect } from 'dva';
import Dimio,{DimioNotice} from 'dimio';
import PaymentForm from './PaymentForm';
import {StripeProvider, Elements } from 'react-stripe-elements';
import config from '../config/config';
import "../style/payment.scss"
const {api} = config.payment;

/**
 *
 *
 * <div id="payment"
 class="app"
 data-key="payment"
 data-test=1
 data-ready=0

 data-stripe-api="pk_test_qwr3GqPrFebKa3goc5cstjd6"
 data-amount="1"
 data-email="ken@dimio.net"
 data-name="Ken Mikuni"
 data-phone="02 0000 0000"
 data-enquiry="Test test"

 data-thankyou="/payment/thankyou"

 data-contract_id=24027
 data-bill_id=20180626
 data-payment_category='mobile'
 />
 */

class PaymentPage extends PureComponent {
  componentWillMount() {
    const {dispatch, core:{defaultValues}} = this.props;

    if(!defaultValues.stripeApi){
      console.error("API key is not set");
//      this.showError("API key is not set");
    }

    /*
    // pre-processing
    if(defaultValues.payment_category == 'mobile') {
      if (defaultValues.contract_id) {
        Dimio.load(api.getBill, {
          contract_id: defaultValues.contract_id,
          bill_id: defaultValues.bill_id
        }).then(res => {
          dispatch({
            type: 'core/updateDefaultValue',
            key: 'amount',
            value: res.data.total,
            ready: true
          });
        }).catch(err => {
          console.error(err);
        });
      }
    }
    */

  }

  render() {
    const { core } = this.props;
    const { defaultValues, ready } = core;
//    console.info(ready);

    return (
      <section id="payment-page" className="page my-2">
        <DimioNotice {...core} />

        <StripeProvider apiKey={defaultValues.stripeApi}>
          <Elements locale="ja">
            <PaymentForm {...this.props} />
          </Elements>
        </StripeProvider>
      </section>
    );
  }
}

export default connect(({ core, payment }) => ({
  core, payment,
}))(PaymentPage);



// WEBPACK FOOTER //
// ./src/pages/payment/components/PaymentPage.js